<template>
  <div>
    <div class="db-filter-modal">
      <div class="db-filter-title-text">Edit KBUB</div>
      <div class="db-filter-edit-form">
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Kategori</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.category" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Jenis Pekerjaan</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.jenpek" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">
            Tingkat Risiko Area Operasi Tambang Inti/Non
          </div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.tresiko_operasi_tambang" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Tingkat Risiko Tambang Inti/Non</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.tresiko_tambang" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">
            Tingkat Risiko Area Operasi Non Tambang
          </div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.tresiko_oprasi_non_tambang" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">
            Tingkat Risiko Non Tambang Inti/Non
          </div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.tresiko_non_tambang" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Kode IUJP</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.iujp_code" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Kode KBLI</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.kbli_code" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Catatan</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.note" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Status</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select" v-model="editData.active">
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal">CANCEL</div>
          <div class="email-button" @click="update">CONFIRM</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../../../services/config'
export default {
  data() {
    return {
      editData: {
        category: '',
        jenpek: '',
        tresiko_operasi_tambang: '',
        tresiko_tambang: '',
        tresiko_oprasi_non_tambang: '',
        tresiko_non_tambang: '',
        iujp_code: '',
        kbli_code: '',
        update_by: '',
        active: true,
        note: '',
      },
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    async update() {
      try {
        const update = this.editData
        update.update_by = this.$store.state.userid
        const url = `${api}/api/v1/m-kbub`
        this.$store.commit('SET_GLOBAL_LOADING', true)

        const { data } = await axios({
          method: 'POST',
          url,
          data: this.editData,
        })

        if (data && data.status == 'success') {
          this.closeModal()
          this.$store.dispatch('mdDatabaseStore/onPageLoad', {
            name: 'currentContent',
            value: 'kbub',
          })
          this.$store.commit('SET_GLOBAL_LOADING', false)
        }
      } catch (err) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(err, 'response.data.message', 'Error')
        )
        this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
